import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdCustomRolesUpdateCustomRoleIdCacheKeys: AllRouteEndpoints[] = [];
